import { useState } from 'react';
import WindowHeight from './WindowHeight';
import SessionMessages from './SessionMessages';
import AuthSession from './AuthSession';
import PermissionGuard from './PermissionGuard';
import InitLogin from './InitLogin';

const Init = () => {
  const [authView, setAuthView] = useState('login');
  const [resetCode, setResetCode] = useState(null);
  const windowHeight = WindowHeight();
  const topOffsetPx = 16;
  const bottomOffsetPx = 16;
  const sessionMessages = SessionMessages(windowHeight - topOffsetPx - bottomOffsetPx);

  const initView = InitLogin()

  const authSession = AuthSession({
    initView,
    setAuthView,
    setResetCode,
    updateMessage: sessionMessages.updateMessage,
  });

  const isLogged = !!authSession.currentUser;
  const finalTopOffsetPx = isLogged ? 80 : 16;
  const maxHeightPx = windowHeight - finalTopOffsetPx - bottomOffsetPx;

  const validSecurity = PermissionGuard({
    currentUser: authSession.currentUser,
    permission: authSession.permission,
    updateMessage: sessionMessages.updateMessage,
    showSessionExpiredOnce: sessionMessages.showSessionExpiredOnce,
    handleLogout: authSession.handleLogout,
    resetSessionExpiredFlag: sessionMessages.resetSessionExpiredFlag,
  });

  const handleLoginReturn = async () => {
    await authSession.handleLogin(sessionMessages.resetSessionExpiredFlag);
  };

  const closeSessionReturn = async () => {
    await authSession.closeSession(sessionMessages.resetSessionExpiredFlag);
  };

  return {
    ...authSession,
    ...sessionMessages,
    ...validSecurity,
    authView,
    topOffsetPx: finalTopOffsetPx,
    maxHeightPx,
    resetCode,
    initView,
    handleLoginReturn,
    closeSessionReturn
  };
};

export default Init;
